import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CertificationBanner from '@/components/feature/CertificationBanner';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/#business`,
  name: 'Pop Pro Tents',
  url: siteUrl,
  description: 'Premium stretch tent rentals and sales nationwide across the USA (with global tent sales), based in Austin, Texas. Weddings, festivals, corporate and private events. Waterproof, fire-rated, fully custom.',
  image: `${siteUrl}/og-image.png`,
  telephone: '+1-656-347-7380',
  email: 'info@popprotents.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Austin',
    addressLocality: 'Austin',
    addressRegion: 'TX',
    addressCountry: 'US',
  },
  areaServed: [
    { '@type': 'Country', name: 'United States' },
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '09:00',
      closes: '14:00',
    },
  ],
  sameAs: [
    'https://www.instagram.com/popprotents/',
    'https://www.facebook.com/popprotents/',
  ],
  priceRange: '$$',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Stretch Tent Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Stretch Tent Rentals' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Custom Tent Sales' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Event Installation' } },
    ],
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <Hero />
      <Features />
      <CertificationBanner />
      <Products />
      <Testimonials />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}